import React, { ChangeEvent, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import LogOutIcon from '@material-ui/icons/ExitToAppOutlined';
import AccountCircleRounded from '@material-ui/icons/AccountCircleRounded';
import Notifications from '@material-ui/icons/Notifications';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import { Link, useLocation, useHistory } from 'react-router-dom';
import { WithStyles } from '@material-ui/styles';
import FeedbackDialog from '../FeedbackDialog';

import styles from './styles';
import { UserData } from '../../redux/selectors/auth';
import { enterpriseUserBuildersRequest } from "../../redux/actions/builders";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/store";
import { selectBuilders } from "../../redux/selectors/builders";
import { MenuItem, Select } from "@material-ui/core";
import { authEnterpriseUserRequest } from "../../redux/actions/auth";

type Props = {
  onLogOut: () => void;
  user: UserData;
} & WithStyles<typeof styles>;

const UserToolbar: React.FC<Props> = props => {
  const { classes, onLogOut, user } = props;
  const greetMessage = `Welcome, ${user.firstName} ${user.lastName}`;

  const dispatch = useDispatch();
  const builders = useSelector((state: AppState) => selectBuilders(state));
  const location = useLocation();
  const history = useHistory();
  const hideSwitch = [
    "/settings",
    "/reports",
    "/integrations",
    "/training",
    "/sales-training",
  ].includes(location.pathname);

  const hideDefaultBuilderView = [
    "/content-settings",
    "/disclosures",
    "/messaging",
  ].includes(location.pathname)

  useEffect(() => {
    if (user.isEnterprise && user.username && (!builders || builders.length === 0)) {
      dispatch(enterpriseUserBuildersRequest(user.username));
    }
  }, [dispatch, user, builders]);

  const handleBuilderChange = (
    event: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const builderId = Number(event.target.value);

    dispatch(
      authEnterpriseUserRequest({
        username: user.username,
        builder_id: builderId,
        redirect: false
      })
    );

    if (location.pathname === "/reportMonthly") {
      const searchParams = new URLSearchParams(location.search);

      searchParams.set("builderId", String(builderId));

      if (user.enterpriseId) {
        searchParams.set("enterpriseId", String(user.enterpriseId));
      }

      history.replace({
        pathname: location.pathname,
        search: searchParams.toString()
      });
    }
  };

  useEffect(() => {
    if (
      user.isEnterprise &&
      !user.builderId &&
      builders?.length > 0 &&
      hideDefaultBuilderView
    ) {
      dispatch(
        authEnterpriseUserRequest({
          username: user.username,
          builder_id: builders[0].builder_id,
          redirect: false
        })
      );
    }
  }, [
    user,
    builders,
    dispatch,
    location.pathname,
    hideDefaultBuilderView,
  ]);

  useEffect(() => {
    // @ts-ignore
    Canny('initChangelog', {
      appID: '641b2057cea6d145e08661b9',
      position: 'bottom',
      align: 'right',
    });
  }, []);

  return (
    <Toolbar classes={{ root: classes.root }}>
      {user.isEnterprise && !hideSwitch && builders?.length > 0 && (
        <div style={{ marginRight: "20px" }}>
          <Select
            value={user.builderId}
            onChange={handleBuilderChange}
            displayEmpty
            className={classes.builderSelect}
            MenuProps={{
              PaperProps: {
                className: classes.builderMenuPaper
              }
            }}
          >
            {!hideDefaultBuilderView && (
              <MenuItem value={0} className={classes.builderMenuItem}>
                All Builders
              </MenuItem>
            )}
            {builders.map(builder => (
              <MenuItem
                key={builder.builder_id}
                value={builder.builder_id}
                className={classes.builderMenuItem}
              >
                {builder.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      )}

      <div className={classes.spacer} />
      <div className={classes.userGreeting}>
        <Typography variant="h5">{greetMessage}</Typography>
      </div>
      <FeedbackDialog />
      <div className={classes.iconsContainer}>
        <Tooltip title="Edit Profile" placement="right-start" arrow interactive TransitionProps={{ timeout: 600 }} TransitionComponent={Zoom}>
          <IconButton component={Link} to="/account">
            <AccountCircleRounded fontSize="large" />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Notifications"
          placement="right-start"
          arrow
          interactive
          TransitionProps={{ timeout: 600 }}
          TransitionComponent={Zoom}
          data-canny-changelog
        >
          <IconButton>
            <Notifications
              className={classes.notificationIcon}
              fontSize="large"
            />
          </IconButton>
        </Tooltip>

        <div className="canny-changelog"
          data-board-token="<YOUR_BOARD_TOKEN>"
          data-dark-mode="<true/false>"
          data-hide-powered-by="<true/false>"
          data-show-subscribe="<true/false>"
          data-title="Hello World"
        ></div>

        <div className={classes.logout}>
          <Tooltip
            title="Log Out"
            placement="right-start"
            arrow
            interactive
            TransitionProps={{ timeout: 600 }}
            TransitionComponent={Zoom}
          >
            <IconButton onClick={onLogOut}>
              <LogOutIcon fontSize="large" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

    </Toolbar>
  );
};

export default React.memo(UserToolbar);
